import { Review, ReviewWithSummary } from '@src/lib/__generated/sdk';

export function getTop3ReviewsWithComments(
	selectedReviews: string[] | null | undefined,
	reviews: ReviewWithSummary | undefined
): Review[] {
	if (!selectedReviews || !reviews?.reviews) return [];
	return selectedReviews
		.map((reviewId) => reviews.reviews?.find((review) => review?.reviewId === reviewId))
		.filter((review): review is Review => review != null)
		.filter((review) => review.comments && review.comments.trim() !== '')
		.slice(0, 3);
}
